import TR from 'utils/TR';
import Honeycomb from 'components/common/Honeycomb';


import T from 'utils/T';
import ex from 'utils/ex';
import { numberWithComma } from 'utils/number';
import VBar from '../ReportBloodGlocose/VBar';
import SummaryBox from '../ReportBloodGlocose/SummaryBox';
import HBox from 'components/common/HBox';
import Segment from 'components/common/Segment';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import Dot from 'components/common/Dot';

export default function ExerciseSummary(props) {
  const {
    viewMode = 'ReportExerciseSteps',
    stepData,
    caloryData,
    ...rest
  } = props || {};
  return (
    <div {...ex('ExerciseSummary', rest)}>
      <Segment
        {...ex('Summary', {
          direction: DIRECTION_VERTICAL,
        })}
      >
        <HBox {...ex('SummaryTitle')} between>
          <div>
            {T('일평균 활동')}
          </div>
        </HBox>
        <HBox {...ex('SummaryItems')} between>
          {viewMode === 'ReportExerciseSteps' && (
            <SummaryBox
              {...{
                caption: T('걸음수'),
                value: numberWithComma(stepData?.daily_avg_step_cnt),
                unit: T('보'),
              }}
            />
          )}
          {viewMode === 'ReportExerciseCalories' && (
            <SummaryBox
              {...{
                caption: T('소모칼로리'),
                value: numberWithComma(caloryData?.daily_avg_cal_amt),
                unit: T('kcal'),
              }}
            />
          )}
          <VBar />
          {viewMode === 'ReportExerciseSteps' && (
            <SummaryBox
              {...{
                caption: T('활동시간'),
                value: numberWithComma(stepData?.daily_avg_active_time),
                unit: T('분'),
              }}
            />
          )}
          {viewMode === 'ReportExerciseCalories' && (
            <SummaryBox
              {...{
                caption: T('활동시간'),
                value: numberWithComma(caloryData?.daily_avg_active_time),
                unit: T('분'),
              }}
            />
          )}
        </HBox>
      </Segment>

      <Segment
        {...ex('Summary', {
          direction: DIRECTION_VERTICAL,
        })}
      >
        <HBox {...ex('SummaryTitle')} between>
          <div>
            {T('식후 평균 활동')}
          </div>
        </HBox>
        <HBox {...ex('SummaryItems')} between>
          {viewMode === 'ReportExerciseSteps' && (
            <SummaryBox
              {...{
                caption: T('걸음수'),
                value: numberWithComma(stepData?.meal_2hr_after_avg_step_cnt),
                unit: T('보'),
              }}
            />
          )}
          {viewMode === 'ReportExerciseCalories' && (
            <SummaryBox
              {...{
                caption: T('소모칼로리'),
                value: numberWithComma(caloryData?.meal_2hr_after_avg_cal_amt),
                unit: T('kcal'),
              }}
            />
          )}
          <VBar />
          {viewMode === 'ReportExerciseSteps' && (
            <SummaryBox
              {...{
                caption: T('활동시간'),
                value: numberWithComma(stepData?.meal_2hr_after_avg_active_time),
                unit: T('분'),
              }}
            />
          )}
          {viewMode === 'ReportExerciseCalories' && (
            <SummaryBox
              {...{
                caption: T('활동시간'),
                value: numberWithComma(caloryData?.meal_2hr_after_avg_active_time),
                unit: T('분'),
              }}
            />
          )}
          <VBar />
          {viewMode === 'ReportExerciseSteps' && (
            <SummaryBox
              {...{
                caption: T('혈당 감소'),
                value: T('-{0}', numberWithComma(stepData?.meal_2hr_after_avg_bld_sugr_decrease_amt)),
                unit: T('mg/dL'),
              }}
            />
          )}
          {viewMode === 'ReportExerciseCalories' && (
            <SummaryBox
              {...{
                caption: T('혈당 감소'),
                value: T('-{0}', numberWithComma(caloryData?.meal_2hr_after_avg_bld_sugr_decrease_amt)),
                unit: T('mg/dL'),
              }}
            />
          )}
        </HBox>
      </Segment>

      <Segment
        {...ex('Summary', {
          direction: DIRECTION_VERTICAL,
        })}
      >
        <HBox {...ex('SummaryTitle')} between>
          <div>
            {T('권장 목표 달성')}
          </div>
        </HBox>
        <HBox {...ex('SummaryItems')} between>
          {viewMode === 'ReportExerciseSteps' && (
            <SummaryBox
              {...{
                caption: T('5000보 이상'),
                value: numberWithComma(stepData?.active_days_over_5000),
                unit: T('일'),
              }}
            />
          )}
          {viewMode === 'ReportExerciseCalories' && (
            <SummaryBox
              {...{
                caption: T('5000보 이상'),
                value: numberWithComma(caloryData?.active_days_over_5000),
                unit: T('일'),
              }}
            />
          )}
        </HBox>
      </Segment>
    </div>
  );
}